function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M255.12 255.116V106.3h-49.61V70.87h-28.35v35.43h-28.34v70.87h-14.18V56.69L28.34 0v255.116H0v28.35h283.466v-28.35H255.12zM85.04 177.17v77.946H56.69V47.24L106.3 73.7v103.47H85.04zm85.04 77.956h-56.7V205.51h56.7v49.616zm56.69-.01h-28.35V177.17h-21.26v-42.52h49.61v120.466z"
})));